import React from 'react'

function Benifits() {
  return (
    <div>
                <section id="about" class="about section-bg">
                <div class="container" data-aos="fade-up">

                <div class="row no-gutters">
                    <div class="content col-xl-5 d-flex align-items-stretch">
                    <div class="content">
                        <h3>Benefits Of Using 3D Scanning In Your Project</h3>
                        <p>

                        There are numerous benefits to using laser scanning services for a wide range of industries and applications. Here are some of the key benefits
                        </p>
                        {/* <a href="#" class="about-btn"><span>About us</span> <i class="bx bx-chevron-right"></i></a> */}

                       
                    </div>
                    </div>
                    <div class="col-xl-7 d-flex align-items-stretch">
                    <div class="icon-boxes d-flex flex-column justify-content-center">
                        <div class="row">
                        <div class="col-md-6 icon-box" data-aos="fade-up" data-aos-delay="100">
                            <i class="bi bi-graph-up-arrow"></i>
                            <h4>Highly accurate measurements of objects and environments.</h4>
                          
                        </div>
                        <div class="col-md-6 icon-box" data-aos="fade-up" data-aos-delay="200">
                            <i class="bx bx-cube-alt"></i>
                            <h4>Preservation and restoration of historical structures.</h4>
                    
                        </div>
                        <div class="col-md-6 icon-box" data-aos="fade-up" data-aos-delay="300">
                            <i class="bx bx-images"></i>
                            <h4>Quick and efficient data capture</h4>
                           
                        </div>
                        <div class="col-md-6 icon-box" data-aos="fade-up" data-aos-delay="400">
                            <i class="bx bx-shield"></i>
                            <h4>Ability to capture data in dangerous or hard-to-reach areas</h4>
                          
                        </div>
                        </div>
                    </div>
                    </div>
                </div>

                </div>
            </section>
    </div>
  )
}

export default Benifits